RivalIQ.apps.AccountSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.LandscapeEmailControl = RivalIQ.views.ItemView.extend({
        template: '#landscapeEmailControlTemplate',

        ui: {
            checkboxes: '[type="checkbox"]',
            save: '.x-save'
        },

        eventsNotToDebounce: {
            'click @ui.save': 'onSave',
            'click .x-check': 'checkAll',
            'click .x-uncheck': 'uncheckAll'
        },

        loadData: function (callback) {
            const me = this;

            RivalIQ.data.landscapes.fetch().done(function (landscapes) {
                me.collection = landscapes;
                callback();
            });
        },

        serializeData: function () {
            const me = this;

            return {
                landscapes: me.collection.toJSON()
            };
        },

        uncheckAll: function () {
            const me = this;
            me.ui.checkboxes.prop('checked', false);
        },

        checkAll: function () {
            const me = this;
            me.ui.checkboxes.prop('checked', true);
        },

        onSave: function () {
            const me = this;

            me.ui.save.button('loading');

            const ids = _.map(me.ui.checkboxes.not(':checked'), function (cb) {
                return $(cb).val();
            });

            const landscapes = _.clone(_.get(me.model.get('settings'), 'landscapes', {}));

            // TODO will not re opt-in for emails
            const allOff = {};
            _.each(RivalIQ.enums.email.type, function (typeId) {
                allOff[typeId] = false;
            });

            _.forEach(ids, function (id) {
                _.set(landscapes, [id, 'email', 'enabled'], allOff);
            });

            me.model.patchSettings({
                landscapes: landscapes
            }).fail(function () {
                me.ui.save.button('reset');
                RivalIQ.execute('alert:danger', 'An error occurred submitting your request. Please try again');
            });
        }
    });
});
